import { render, staticRenderFns } from "./Transportadoras.vue?vue&type=template&id=03be702a&scoped=true&"
import script from "./Transportadoras.vue?vue&type=script&lang=js&"
export * from "./Transportadoras.vue?vue&type=script&lang=js&"
import style0 from "./Transportadoras.vue?vue&type=style&index=0&id=03be702a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03be702a",
  null
  
)

export default component.exports